import styled from 'styled-components';

export const StyledButton = styled.button`
    position: relative;
    box-sizing: content-box;
    text-transform: uppercase;
    padding: .5rem 1rem;
    color: #222;
    font-weight: 700;
    font-family: inherit;
    background-image: url(${(props) => props.bg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 1.3rem;
    line-height: 1.5;
    width: 25rem;
    height: 5rem;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;

    & span {
        display: block;
        width: 100%;
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1200px) {
        font-size: 1.4rem;
    }

    @media screen and (max-width: 768px) {
        font-size: 1.3rem;
    }

    &.clicked {
        background-image: url(${(props) => props.bg}) !important;
    }
`;

export const StyledOpenButton = styled.button`
    position: relative;
    box-sizing: content-box;
    text-transform: uppercase;
    background-image: url(${(props) => props.bg}) !important;
    color: #add8e6 !important;
    padding: .5rem 1rem;
    font-weight: 700;
    font-family: inherit;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 1.3rem;
    width: 25rem;
    height: 5rem;
    text-align: center;
    border-radius: 15px 0px;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;

    & div {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1200px) {
        font-size: 1.4rem;
    }

    @media screen and (max-width: 768px) {
        font-size: 1.3rem;
    }

    & span {
        display: block;
        
        &:nth-of-type(2) {
            margin-left: 2rem;
        }
    }
   
    &.clicked {
        background-image: url(${(props) => props.bg})!important;
    }

`;